"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCanBuyCredits = void 0;
const use_can_write_organization_1 = require("@app/util/hooks/use-can-write-organization");
/**
 * Whether the person reading the panel may spend the organization's money.
 *
 * Separate from whether they may SEE the balance: reading is workspace-level and every manager
 * with the assistant has it, buying is organization-level and most of them do not.
 *
 * The role matching itself lives in `useCanWriteOrganization` — the onboarding bonus gates on
 * exactly the same question, and two copies of that role list would drift.
 */
const useCanBuyCredits = () => (0, use_can_write_organization_1.useCanWriteOrganization)();
exports.useCanBuyCredits = useCanBuyCredits;
exports.default = exports.useCanBuyCredits;
